<template>
  <section class="w-full bg-white border-solid border rounded-xl border-gray-300 !p-1 flex justify-between h-[50px]">
    <!-- start -->
    <section class="flex items-center">
      <Button
        class="h-10"
        severity="secondary"
        text
        @click="menuButtonClicked"
        v-tooltip.bottom="{ value: layoutStore.sidebarOpen ? 'Close Drawer' : 'Open Drawer', pt: {text: 'text-sm'}}"
      >
        <template #icon>
          <span :key="menuIcon" class="material-symbols-rounded text-xl">{{ menuIcon }}</span>
        </template>
      </Button>
    </section>

    <!-- middle -->
    <section class="flex items-center">
      <span class="text-xl font-medium text-slate-700">Erebus Console</span>
    </section>

    <!-- end -->
    <section class="flex items-center space-x-1">
      <Button
        class="h-10"
        severity="secondary"
        text
        @click="toggleUserMenu"
        aria-haspopup="true"
        aria-controls="user-menu"
        v-tooltip.bottom="{ value: 'Account', pt: {text: 'text-sm'}}"
      >
        <template #icon>
          <span class="material-symbols-rounded text-xl">account_circle</span>
        </template>
      </Button>

      <Menu
        ref="userMenuRef"
        id="user-menu"
        :model="userMenuItems"
        :popup="true"
      >
        <template #start>
          <div class="px-3 py-2 border-b border-gray-100">
            <div class="font-medium text-sm text-gray-900">{{ displayName }}</div>
            <div class="text-xs text-gray-500">{{ displayEmail }}</div>
          </div>
        </template>
      </Menu>
    </section>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import Button from 'primevue/button'
import Menu from 'primevue/menu'
import { useRouter } from 'vue-router'
import { useLayoutStore } from '@/stores/layoutStore'
import { useAuthStore } from '@/stores/authStore'
import { getRuntimeConfig } from '@erebus/runtime-config'
import type { MenuItem } from 'primevue/menuitem'

const router = useRouter()
const layoutStore = useLayoutStore()
const authStore = useAuthStore()

const userMenuRef = ref()

const menuIcon = computed(() => {
  return layoutStore.sidebarOpen ? 'left_panel_close' : 'left_panel_open'
})

const displayName = computed(() => {
  const emp = authStore.currentEmployee
  return emp ? `${emp.firstName} ${emp.surname}` : 'User'
})

const displayEmail = computed(() => {
  return authStore.currentEmployee?.email ?? ''
})

const { useCookieAuth } = getRuntimeConfig()

const userMenuItems = computed<MenuItem[]>(() => {
  const items: MenuItem[] = []

  if (useCookieAuth) {
    items.push({
      label: 'Security Settings',
      icon: 'pi pi-shield',
      command: () => router.push({ name: 'security' })
    })
    items.push({ separator: true })
  }

  items.push({
    label: 'Sign Out',
    icon: 'pi pi-sign-out',
    class: 'text-red-500',
    command: () => router.push({ name: 'logout' })
  })

  return items
})

function menuButtonClicked(): void {
  layoutStore.toggleSidebar()
}

function toggleUserMenu(event: Event): void {
  userMenuRef.value.toggle(event)
}
</script>
